module.exports = __webpack_public_path__ + "img/icon-door.b6d6cef0.svg";